import { createContext, useContext, useRef, useCallback, useMemo } from 'react';

const OverviewRefreshContext = createContext({
	setRefreshCallback: () => {},
	requestRefresh: () => {},
});

export const useOverviewRefresh = () => useContext(OverviewRefreshContext);

export const OverviewRefreshProvider = ({ children }) => {
	const refreshCallbackRef = useRef(null);

	const setRefreshCallback = useCallback(callback => {
		refreshCallbackRef.current = callback;
	}, []);

	const requestRefresh = useCallback(() => {
		refreshCallbackRef.current?.();
	}, []);

	const value = useMemo(() => ({
		setRefreshCallback,
		requestRefresh,
	}), [setRefreshCallback, requestRefresh]);

	return (
		<OverviewRefreshContext.Provider
			value={value}
		>
			{children}
		</OverviewRefreshContext.Provider>
	);
};
